import { createDrawer, Drawer } from '@nexelem/drawer';
import { SavedViewItem } from './SavedViewItem';
import { useTableName } from '../../utils';
import { selectSavedViews, useSaveViewStore } from '../SaveViewStore';
import { useTableTranslation } from '../../translations';

const SavedViewsDrawer = () => {
  const { t } = useTableTranslation();
  const tableName = useTableName();
  const savedViews = useSaveViewStore(selectSavedViews(tableName));

  return (
    <Drawer>
      <Drawer.Header title={<div className="text-t24-sb">{t('savedViews')}</div>} onClose={closeSavedViewsDrawer} />

      <Drawer.Content>
        <div className="flex flex-col gap-2">
          {savedViews.map((data) => (
            <SavedViewItem data={data} key={data.id} />
          ))}
        </div>
        {savedViews.length === 0 && <div className="text-center text-s16">{t('noSavedViews')}</div>}
      </Drawer.Content>
      <Drawer.Footer></Drawer.Footer>
    </Drawer>
  );
};

export const { closeSavedViewsDrawer, openSavedViewsDrawer } = createDrawer(SavedViewsDrawer, {
  name: 'SavedViewsDrawer',
  width: 420,
  slot: 'right',
  drawerId: () => 'saved-views-drawer',
});
